import { NavigateFunction } from 'react-router-dom'

import { PageEventGroup } from '../tracking/groups/pages'

export const navigateUsingSavedState = (
	state: { pathname: string; search: string },
	navigateFunc: NavigateFunction,
	trackEvent: (...args: unknown[]) => void,
) => {
	trackEvent(PageEventGroup.events.restore())
	navigateFunc(
		{
			pathname: state.pathname,
			search: state.search,
		},
		{ replace: true },
	)
}
